module.exports = __webpack_public_path__ + "Lato-Light.4afee4c98483c85a3346.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Light.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Light.eot
// module chunks = styles